export function DecorateAll(decorator: MethodDecorator) {
  // eslint-disable-next-line
  return (target: any) => {
    const descriptors = Object.getOwnPropertyDescriptors(target.prototype);
    for (const [propName, descriptor] of Object.entries(descriptors)) {
      if (!(typeof descriptor.value == 'function' && propName != 'constructor')) {
        continue;
      }
      decorator(target, propName, descriptor);
      Object.defineProperty(target.prototype, propName, descriptor);
    }
  };
}
